module.exports = __webpack_public_path__ + "static/media/bj.73ca1704.svg";